<script>
    // import { Line } from 'vue-chartjs'
    // import {Bar} from 'vue-chartjs'
    import {Line, mixins} from 'vue-chartjs'

    export default {
        name: "LineChart",
        extends: Line,
        mixins: [mixins.reactiveProp],
        props: {
            options: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        data() {
            return {

                options_: {
                    responsive: true,
                    maintainAspectRatio: false,
                    // scales: {
                    //     yAxes: [{
                    //         display: true,
                    //
                    //         ticks: {
                    //             callback: function(value, index, values) {
                    //                 console.log("value: ", value);
                    //                 console.log("index: ", index);
                    //                 console.log("values: ", values);
                    //
                    //                 function getValue(value) {
                    //                     if(value < 50) return 'f'
                    //                     return 'g'
                    //                 }
                    //
                    //                 return getValue(value)
                    //                 // for a value (tick) equals to 8
                    //                 // return yLabels[value];
                    //                 // 'junior-dev' will be returned instead and displayed on your chart
                    //             },
                    //             suggestedMax: 100,
                    //             beginAtZero: true
                    //         }
                    //     }]
                    // },

                    ...this.options
                }
            }
        },

        mounted() {
            this.renderChart(this.chartData, this.options_)
        }

    }
</script>

<style scoped>

</style>
